<template>
    <div class="menu-container">
        <div :class="['flex flex-row w-full justify-between space-x-4']">
            <BtnMenu
                v-if="group.description && group.description.length > 0"
                ref="menuInfo"
                left-icon="info"
                :menu-title="t('group:header.options.header_description')"
                size="sm"
                menu-class="md:flex info-menu text-center flex-1 shadow-light-base md:shadow-none"
                :options="options"
                class="w-full"
                :variant="screen.maxSM ? 'filled' : 'outlined'"
                menu-placement="bottom-end"
                menu-popper-class="break-words max-w-md"
                ><template #menu
                    ><div
                        class="p-3"
                        v-text="group.description"
                    ></div></template
            ></BtnMenu>
            <!-- End info menu -->
            <BtnMenuShare
                :share-title="
                    t('share.title', {
                        name: group.name,
                    })
                "
                :share-url="url"
                :variant="screen.maxMD ? 'filled' : 'outlined'"
                :elevated="screen.maxMD"
                size="sm"
                class="w-full"
                menu-class="flex-1"
            />

            <Btn
                v-if="inGroup(group.id)"
                v-tooltip="t('tooltip:leave:group')"
                :variant="screen.maxSM ? 'filled' : 'outlined'"
                size="sm"
                icon="logout"
                class="flex-1 md:flex"
                :elevated="screen.maxMD"
                @click="leave"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import stripWhiteSpaceSpecialCharacters from '@/helpers/stripWhiteSpaceSpecialCharacters';
import route from '@router/route';
import BtnMenuShare from '@/components/BtnMenuShare';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'GroupShowMenu',
    components: {
        BtnMenuShare,
    },
    props: {
        withBanner: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const { t } = useTranslation('group');
        return { t };
    },
    data() {
        return {
            buttonMenuActive: {
                menu: false,
            },
        };
    },
    computed: {
        ...mapGetters({
            group: 'group/group',
            leavingGroup: 'group/leaveProgress',
            joiningGroup: 'group/joinProgress',
        }),
        ...mapGetters({ userGroups: 'user/groups', inGroup: 'user/inGroup' }),
        ...mapGetters({ user: 'auth/user' }),
        ...mapGetters('ui', ['screen']),
        url() {
            return route('groups.show', {
                groupName: this.group.slug,
                id: this.group.id,
                ref: this.user === null ? undefined : this.user.userid,
            });
        },
        modalTranslations() {
            return {
                title: this.t('popup.leave.h3'),
                submitText: this.t('popup.leave.confirm_btn_label'),
            };
        },
        options() {
            return [
                {
                    label: this.group.description,
                },
            ];
        },
    },
    methods: {
        async leave() {
            if (this.inGroup(this.group.id) && !(this.leavingGroup || this.joiningGroup)) {
                const confirmed = await this.$modal.confirm({
                    title: this.modalTranslations.title,
                    submitText: this.modalTranslations.submitText,
                });

                if (confirmed) {
                    this.$store.dispatch('group/leave', { group: this.group });
                }
            }
        },
        stripWhiteSpaceSpecialCharacters,
    },
};
</script>
<style lang="scss" scoped>
.menu-container {
    @apply flex flex-row justify-between container w-full py-4 bg-white space-x-4;

    @screen md {
        @apply absolute top-0 right-0 justify-end p-6 bg-transparent w-auto;
    }
}
</style>
